import basePalette from "../base.palette";

const darkThemePalette = Object.assign({}, basePalette);

darkThemePalette.pagePrimaryBgColor = darkThemePalette.secondary.main;
darkThemePalette.fontPrimaryColor = darkThemePalette.secondary.text;
darkThemePalette.tooltipPrimaryColor = darkThemePalette.primary.text;
darkThemePalette.listItemHoverColor = darkThemePalette.primary.main;
darkThemePalette.inputBaseBorderColor = darkThemePalette.grey.border;
darkThemePalette.inputBeforeBorderColor = darkThemePalette.grey.light;
darkThemePalette.inputAfterBorderColor = darkThemePalette.primary.light;
darkThemePalette.hoveredInputBeforeBorderColor = darkThemePalette.primary.light;
darkThemePalette.inputRootColor = darkThemePalette.secondary.contrastText;
darkThemePalette.inputPlaceholderColor = darkThemePalette.grey.main;
darkThemePalette.inputLabelFocusedColor = darkThemePalette.primary.text;
darkThemePalette.inputLabelActiveColor = darkThemePalette.primary.active;
darkThemePalette.inputLabelErrorColor = darkThemePalette.error.main;
darkThemePalette.formLabelColor = darkThemePalette.grey.dark;
darkThemePalette.progressColor = darkThemePalette.primary.light;
darkThemePalette.expandIconColor = darkThemePalette.primary.light;
darkThemePalette.radioColor = darkThemePalette.grey.text;
darkThemePalette.cellColor = darkThemePalette.secondary.contrastText;
darkThemePalette.stepIconBgColor = darkThemePalette.grey.contrastText;
darkThemePalette.stepIconColor = darkThemePalette.secondary.main;
darkThemePalette.stepLineColor = darkThemePalette.grey.light;
darkThemePalette.buttonsBorderColorActive = darkThemePalette.primary.active;
darkThemePalette.inputDisabledTextColor = darkThemePalette.primary.text;

export default darkThemePalette;
